import { Component } from "@angular/core";
import { ImpersonationService } from "../auth/apigee/impersonation.service";

@Component({
    selector: "static-dashboard-direct-definition",
    templateUrl: "./staticDashboardDirectDefinition.component.html",
    standalone: false
})
export class StaticDashboardDirectDefinitionComponent {

    //Management & Control
    //Contract signing
    public get managementControlPastUnsignedContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlInmediateUnsignedContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlForecastUnsignedContractsHostVisible(): boolean {
        return true;
    }
    //Contract expirations
    public get managementControlPastExpiringContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlInmediateExpiringContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlForecastExpiringContractsHostVisible(): boolean {
        return true;
    }
    //Risks
    public get managementControlActiveWorkersWoPPEHostVisible(): boolean {
        return true;
    }
    public get managementControlPendingActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlExpiredActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlProcessingActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlFitActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }

    public get managementControlAbsencesHostVisible(): boolean {
        return true;
    }

    constructor(private impersonationService: ImpersonationService) {
    }

    public get dashboardOwner(): string {
        return this.impersonationService.isImpersonating ? this.impersonationService.getUserDisplayName() : "";
    }
}
